import { mockData } from "Signups/SignupsPublicPage/mockData";
import FnrFetch4 from "Utilities/FnrFetch/FnrFetch4";

const API = {
  getPaymentPageData: (fundID, postData) => {
    return new FnrFetch4(
      `/give/${fundID}/paymentData`,
      postData,
      mockData.shouldMock ? mockData.getPaymentPageData : null
    );
  },
};

export default API;
